import {
  IconSelect as BonsaiIconSelect,
  tokens
} from '@arvoreeducacao/bonsai-ds'
import styled from 'styled-components'

export const IconSelectWrapper = styled.div<{
  isStoryTreeComunicarPath?: boolean
}>`
  display: flex;
  align-items: center;
  justify-content: flex-start;

  width: 100%;

  margin-top: ${({ isStoryTreeComunicarPath }) =>
    isStoryTreeComunicarPath ? 0 : '34px'};
  margin-left: ${tokens.spacing.horizontalXsmall};
  margin-bottom: -${tokens.spacing.horizontalMedium};
  padding-right: ${tokens.spacing.horizontalMedium};

  @media (min-width: ${tokens.breakpoints.tablet}px) {
    justify-content: flex-end;
    margin-top: ${({ isStoryTreeComunicarPath }) =>
      isStoryTreeComunicarPath ? 0 : tokens.spacing.verticalXxxlarge};
  }
`

export const IconSelect = styled(BonsaiIconSelect)`
  @media (max-width: ${tokens.breakpoints.desktop}px) {
    div[role='listbox'] {
      min-width: 244px;
    }
  }
`
